<template>
    <div>
                <div class="vx-card p-6">
                    <div class="vx-row">
                        <div class="vx-col md:w-1/4 w-full">
                            <label class="vs-input--label">{{ $t('multipleChoice.quizname') }}</label>
                            <vs-input class="w-full" v-model="schoolQuizName" type="text" data-vv-validate-on="blur" />
                        </div>
                        <div class="vx-col md:w-1/4 w-full">
                            <label class="vs-input--label">{{ $t('multipleChoice.level') }}</label>
                            <v-select class="" v-model="selectPriority" :options="priorityOptions" :clearable="false"
                                :reduce="(option) => option.value">
                                <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                            </v-select>
                        </div>
                        <vs-button icon="icon-search" icon-pack="feather" color="primary" class="mt-6 ml-4"
                            @click="getExam">
                            {{ $t('multipleChoice.search') }}
                        </vs-button>
                        <vs-button icon="icon-plus" icon-pack="feather" color="primary" class="mt-6 ml-8"
                            @click="addListQuestion">
                            {{ $t('multipleChoice.quizadd') }}
                        </vs-button>
                    </div>

                </div>
                <div class="vx-card px-4">
                    <ag-grid-vue style="height: 55vh" ref="agGridTable"
                        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef" :rowData="dataExam" :animateRows="true"
                        :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                         @grid-ready="onGridReady"
                        :autoSizeStrategy="autoSizeStrategy">
                    </ag-grid-vue>
                    <div class="vx-row mt-8" v-if="totalElements > 0">
                        <div class="vx-col md:w-1/2 w-full">
                            <span class="content-page font-bold">Hiển thị: </span>
                            <span class="text-page">
                                {{ countElementPage > totalElements ? totalElements : countElementPage }} / {{
                                totalElements
                            }}
                            </span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage" />
                        </div>
                    </div>
                </div>
    </div>
</template>
<script>
import vSelect from 'vue-select';
import { AgGridVue } from "ag-grid-vue";
import CellRendererMultipleChoiceExercises from "./cell-renderer/CellRendererMultipleChoiceExercises.vue";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import moment from "moment";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import { ModuleRegistry } from '@ag-grid-community/core';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    components: {
        vSelect,
        AgGridVue,
        CellRendererMultipleChoiceExercises,
    },
    data() {
        return {
            gridApi: null,
            typeOfExercise: null,
            selectPriority: null,
            schoolQuizName: null,
            categoryOptions: [],
            dataExam: [],
            pageNumber: 0,
            pageSize: 20,
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('multipleChoice.stt'),
                    field: 'stt',
                    width: 100
                },
                {
                    headerName: this.$t('multipleChoice.quizname'),
                    field: 'schoolQuizName',
                    width: 300,
                },
                {
                    headerName: this.$t('multipleChoice.level'),
                    field: 'level',
                    width: 200,
                },
                {
                    headerName: this.$t('multipleChoice.typeOfExercise'),
                    field: 'typeOfExercise',
                    width: 300,
                },
                {
                    headerName: this.$t('menuOrganization.createdDate'),
                    field: 'createdDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.updatedDate'),
                    field: 'modifiedDate',
                    width: 250
                },
                {
                    headerName: this.$t('multipleChoice.actions'),
                    field: 'actions',
                    width: 200,
                    cellRenderer: 'CellRendererMultipleChoiceExercises',
                    suppressSizeToFit: true,
                },
            ],

            autoSizeStrategy: {
                type: 'fitGridWidth',
            },
            priorityOptions: [
                { value: null, label: this.$t('multipleChoice.all') },
                { value: 1, label: this.$t('multipleChoice.easy')},
                { value: 2, label: this.$t('multipleChoice.moderate') },
                { value: 3, label: this.$t('multipleChoice.difficult') },
            ],
            typeOfExerciseOptions: [
                { value: null, label: this.$t('multipleChoice.all') },
                { value: 1, label: this.$t('multipleChoice.homework')},
                { value: 2, label: this.$t('multipleChoice.multiple_choice_exercises') },
            ],
            totalPages: 0,
            countElementPage: 0,
            totalElements: 0,
            currentPage: 1,

        }
    },
    created() {
        this.getExam();
        this.getCategory();
    },
    methods: {
        addListQuestion() {
            this.$router.push(`/user/multiple-choice-question-exercises-info`);
        },
        onGridReady(params) {
            this.gridApi = params.api;
        },

        loadPage: function (currentPage) {
            if (parseInt(currentPage) - 1 != this.pageNumber) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getExam();
            }
        },
        getCategory() {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,

            }
            this.$crm.post('/school-quiz-category/find-by-condition', body).then((response) => {
                this.categoryOptions = response.data.content.map(el => {
                    return {
                        label: el.categoryName,
                        value: el.id
                    }
                })
            })
        },
        getExam() {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                levelType: this.selectPriority ? this.selectPriority : null,
                quizType: this.typeOfExercise ? this.typeOfExercise : null,
                schoolQuizName: this.schoolQuizName
            }
            this.$vs.loading();
            this.$crm.post('/school-quiz/find-by-condition', body).then((response) => {
                this.dataExam = response.data.content.map(el => {
                    el.stt = response.data.content.indexOf(el) + 1;
                    el.createdDate = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY HH:mm') : '';
                    el.modifiedDate = el.modifiedDate ? moment(el.modifiedDate).format('DD/MM/YYYY HH:mm') : '';
                    if(this.priorityOptions){
                        this.priorityOptions.map( t => {
                            if (t.value === el.levelType){
                                el.level = t.label
                            }
                        })
                    }
                    if(this.typeOfExerciseOptions){
                        this.typeOfExerciseOptions.map( t => {
                            if (t.value === el.quizType){
                                el.typeOfExercise = t.label
                            }
                        })
                    }
                    return el;
                })
                this.countElementPage = this.currentPage * this.pageSize;
                this.totalElements = this.dataExam.length
                this.totalPages = response.data.totalPages
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

    },
    watch: {
        '$store.state.isDeleteTopicSet'(val) {
            if (val) {
                this.getExam();
                this.$store.commit('DELETE_TOPICSET', false);
            }
        },
    },
}
</script>
<style>
.required::after {
    content: '* ';
    color: red;
}
</style>
